import React, { useEffect,useState } from "react";
import { LockOutlined, LoginOutlined, MailOutline, PasswordOutlined, Send } from "@mui/icons-material";
import { Box, Button, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { instance } from "../../utils/api";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
function ForgotPassword() {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const Spinner = () => (
		<div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
			<div style={{ width: '30px', height: '30px', borderRadius: '50%', border: '4px solid #ccc', borderTop: '4px solid rgb(255 122 0)', animation: 'spin 1s linear infinite' }}></div>
		</div>
	);


    const handleSendEmail = async () => {
        setLoading(true);
        try {
            const formData = {
                email,
            };
            const response = await instance.post("agents/forgot-password", formData);
            console.log(response.data.message);
            toast.success(response.data.message);
            navigate("/");
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.response.data.error)

        }
        finally {
			setLoading(false);
		}
	};

    return (
        <>
            <div className="app-page-login">
                <div className="app-page-login__wrapper">
                    <div className="app-page-login__card">
                        <h2>Forgot Password</h2>
                        <p>If you have forgotten your password, please enter your account's email address below and submit. You will receive an email that contains a link to set a new password</p>
                        <div className="app-page-login__formgroup">
                            <div className="app-page-login__field">
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <MailOutline sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    <TextField
                                        type="email"
                                        fullWidth
                                        required
                                        id="input-with-sx"
                                        label="Email"
                                        placeholder="Enter your email"
                                        variant="standard"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Box>
                            </div>
                            <div className="app-page-login__button">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleSendEmail}
                                    disabled={loading}
                                >
                          {loading ? <Spinner /> :  <Send />} Submit
                                </Button>
                            </div>
                        </div>
                        <div className="app-page-login__rememberpassswprd">
                            <Link to="/">
                                <Button style={{ padding: 0 }}>Return to Login Page</Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer/>
        </>
    )
}

export default ForgotPassword;
